export const state = {
  bids: [],
  suggestions: [],
}
